import { Component, Input, ChangeDetectorRef, OnInit, OnChanges, SimpleChanges, ViewContainerRef, ComponentRef, Output, EventEmitter, ViewEncapsulation, ElementRef, AfterViewInit, OnDestroy, Renderer2, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewportService } from 'src/app/services/viewport.service'; // Importa o serviço
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'; import { ShoppingCartComponent } from 'src/app/components/shopping-cart/shopping-cart.component';
import { PPlayerComponent } from '../p-player/p-player.component';
import { SkeletonModule } from 'primeng/skeleton'; import { SidebarCartService } from 'src/app/services/sidebar-cart.service';
import { ChipModule } from "primeng/chip"; import { ShoppingCartService } from 'src/app/services/shopping-cart.service';
import { AvatarModule } from 'primeng/avatar'; import { InputNumberModule } from 'primeng/inputnumber';
import { ButtonModule } from 'primeng/button'; import { InputTextModule } from 'primeng/inputtext';
import { AvatarGroupModule } from 'primeng/avatargroup'; import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ShowProductsComponent } from 'src/app/components/show-products/show-products.component';
import { SidebarModule } from 'primeng/sidebar'; import { SwiperModule, SwiperComponent } from 'swiper/angular';
import { CarouselModule } from 'primeng/carousel';
import { Item } from 'src/app/models/liveshop';
import { VideoItem } from 'src/app/models/video-item.model';
import { SidebarService } from 'src/app/services/sidebar.service';
import { LOCALE_ID } from '@angular/core'; import { VideoModalService } from 'src/app/services/video-modal.service';
import { registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';
registerLocaleData(ptBr);
@Component({
  selector: 'app-inline',
  standalone: true,
  templateUrl: './inline.component.html',
  styleUrls: ['./inline.component.scss'],
  imports: [CommonModule, PPlayerComponent, SwiperModule, AvatarGroupModule, InputTextModule, ShoppingCartComponent, FormsModule, ReactiveFormsModule, InputNumberModule, ShowProductsComponent, SidebarModule, ButtonModule, AvatarModule, ChipModule, CarouselModule, SkeletonModule],
  encapsulation: ViewEncapsulation.Emulated,
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' }
  ]
})
export class InlineComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() height?: number | undefined;
  // 
  @Input() showProducts?: boolean = false;
  @Input() isAdmin: boolean = true;
  @Input() showDescription?: boolean = false;
  @Input() widget_id?: number | undefined;
  @Input() store_id?: number | undefined;
  @Input() template_id?: number | undefined;
  @Input() aspectRatio?: any = '540 / 540';
  @Input() templateType: string | undefined;
  @Input() isCol4: boolean = false;

  get isLandscape(): boolean {
    if (!this.aspectRatio) return false;
    const parts = String(this.aspectRatio).split('/').map(Number);
    return parts.length === 2 && parts[0] > parts[1];
  }
  @Input() instanceId?: string;
  isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  @Output() openSidebar = new EventEmitter<void>();
  private resizeObserver?: ResizeObserver;
  loading: boolean = true;
  constructor(
    private shoppingCartService: ShoppingCartService,
    private sidebarCartService: SidebarCartService,
    private viewportService: ViewportService,
    private sidebarService: SidebarService,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer,
    private host: ElementRef,
    private videoModalService: VideoModalService
  ) { }
  iframeUrl: SafeResourceUrl | null = null;
  @ViewChild(ShowProductsComponent) showProductsList!: ShowProductsComponent;
  @ViewChild(ShoppingCartComponent) shoppingCart!: ShoppingCartComponent;
  hasProduct: boolean = false;
  handleBackButton(): void {
    if (this.hasProduct) {
      this.showAllProductsSidebar2 = true;
    }
    this.showCartSidebar = false;
    this.cdr.detectChanges();
  }
  onVideoLoaded(): void {
    this.loading = false;
  }

  normalizeProductPrices(): void {
    this.selectedVideoUrl.products = this.selectedVideoUrl.products?.map(product => ({
      ...product,
      price: typeof product.price === 'string'
        ? parseFloat(product.price.replace(',', '.'))
        : product.price
    })) ?? [];
  }

  // Flag para controlar o estado do carousel
  showCarousel: boolean = false;

  // Método para alternar o estado
  toggleCarousel(event: MouseEvent) {
    event.stopPropagation(); // Evita propagação do clique
    this.showCarousel = !this.showCarousel;
  }
  ngOnInit(): void {
    // 🔥 Atualiza o contador no carregamento inicial
    this.shoppingCartService.cartCount$.subscribe(count => {
      this.cartCount = count;
    });
    /////////////////////////////////////////
    //this.createVideoPlayerComponent();
  }

  @Input() videoUrls: VideoItem[] = [];
  selectedVideoUrl: VideoItem = {
    uid: '',
    id: -1,
    src: '',
    poster: '',
    products: []  // ✅ Inicialização como array vazio
  };
  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;


  showAllProductsSidebar2: boolean = false;
  selectedSku: number = 0;
  openProductSidebar(sku: string): void {
    let skuformated = Number(sku)

    this.selectedSku = skuformated;
    this.showAllProductsSidebar2 = true;

    // Abrir a sidebar e passar o SKU para o ShowProductsComponent
    this.sidebarService.setSku(skuformated);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['height']) {
      this.calculateLayout();
    }
    if (changes['aspectRatio']) {
      this.calculateLayout();
    }
    if (changes['store_id']) {
    }
    if (changes['template_id']) {
    }
    if (changes['isCol4']) {
    }
    if (changes['videoUrls'] && this.videoUrls.length > 0) {

      this.selectedVideoUrl = this.videoUrls[0]; // Pegando apenas o primeiro vídeo
      this.normalizeProductPrices();
      if (this.videoPlayer) {
        const videoElement = this.videoPlayer.nativeElement;
        videoElement.load(); // Recarrega o vídeo quando a URL é alterada
      }
      this.currentVideoIndex = 0;
      this.slickDesc = this.selectedVideoUrl?.description;
      this.handleTruncatedDesc();
      this.updateNextVideoDetails();

      this.updateVideoThumbnails();
      this.updateVideoPlayer();
      this.loading = false;
    }
    if (changes['showDescription']) {
      this.selectedVideoUrl = this.videoUrls[0];
      this.slickDesc = this.selectedVideoUrl?.description;


    }
    if (changes['widget_uid']) {
    }
  }
  prevVideoThumbnail: string | undefined = '';
  selectedVideoThumbnail: string | undefined = '';
  nextVideoThumbnail: string | undefined;
  showPrevVideoButton: boolean = false;
  showNextVideoButton: boolean = false;
  currentVideoIndex: number = 0;
  playNextVideo(): void {
    if (this.currentVideoIndex < this.videoUrls.length - 1) {
      this.currentVideoIndex++;
      this.updateVideoThumbnails();
      this.updateVideoPlayer();
      this.cdr.detectChanges();
    }
  }

  playPrevVideo(): void {
    if (this.currentVideoIndex > 0) {
      this.currentVideoIndex--;
      this.updateVideoThumbnails();
      this.updateVideoPlayer();
    }
  }
  private updateVideoThumbnails(): void {
    this.selectedVideoThumbnail = this.videoUrls[this.currentVideoIndex]?.thumbnail || '';
    this.prevVideoThumbnail =
      this.currentVideoIndex > 0
        ? this.videoUrls[this.currentVideoIndex - 1]?.thumbnail || ''
        : undefined;
    this.nextVideoThumbnail =
      this.currentVideoIndex < this.videoUrls.length - 1
        ? this.videoUrls[this.currentVideoIndex + 1]?.thumbnail || ''
        : undefined;

    this.showPrevVideoButton = this.currentVideoIndex > 0;
    this.showNextVideoButton = this.currentVideoIndex < this.videoUrls.length - 1;
  }

  private updateVideoPlayer(): void {
    this.selectedVideoUrl = this.videoUrls[this.currentVideoIndex];
    this.normalizeProductPrices();
    if (this.videoPlayer) {
      const videoElement = this.videoPlayer.nativeElement;
      videoElement.load();
      videoElement.play();
      this.isPlaying = true;
    }

    this.slickDesc = this.selectedVideoUrl?.description;
    this.handleTruncatedDesc();
  }
  private updateNextVideoDetails(): void {
    const nextIndex = this.currentVideoIndex + 1;
    this.showNextVideoButton = nextIndex < this.videoUrls.length;

    // Atualizar a thumbnail do próximo vídeo, se existir
    this.nextVideoThumbnail = this.showNextVideoButton
      ? this.videoUrls[nextIndex].thumbnail || 'assets/imgTmp.webp' // Thumbnail padrão caso não exista
      : undefined;
  }

  showBtnVerMais: boolean = true;
  showBtnVerMaisFechar: boolean = false;
  truncatedDesc?: string = '';
  fullViewActive: boolean = false;
  slickDesc?: string = '';
  goVerMaisFechar() {
    this.fullViewActive = false;
    this.showBtnVerMais = true;
    this.showBtnVerMaisFechar = false;
    this.handleTruncatedDesc();
    this.bottomBarHeight = 60;
  }
  handleDivClick(event: Event): void {
    event.stopPropagation(); // Isso sempre será chamado.
    if (this.fullViewActive) {
      this.goVerMaisFechar();
    }
  }
  goVerMais() {
    this.fullViewActive = true;
    this.showBtnVerMaisFechar = true;
    this.showBtnVerMais = false;
    // this.center = this.center - 8;
    // this.bottom3 = this.bottom3 + 8;
    this.truncatedDesc = this.slickDesc;
    this.updateBottomBarHeight();
  }
  @ViewChild('bottomBar') bottomBar!: ElementRef;

  bottomBarHeight = 60;
  updateBottomBarHeight() {
    if (this.bottomBar) {
      this.bottomBarHeight = 100; // Garante um valor padrão
    }
  }
  @Input() viewMode: number = 1;
  handleTruncatedDesc(): void {
    if (!this.slickDesc) {
      this.truncatedDesc = ''; // Garantia de estado vazio
      this.showBtnVerMais = false;
      return;
    }

    if (this.viewMode === 1) {
      // Verifica se precisa truncar (modo compacto)
      if (this.slickDesc.length > 25) {
        this.truncatedDesc = `${this.slickDesc.substring(0, 25)}...`;
        this.showBtnVerMais = true;
      } else {
        this.truncatedDesc = this.slickDesc;
        this.showBtnVerMais = false;
      }
    } else {
      // Verifica se precisa truncar (modo expandido)
      if (this.slickDesc.length > 120) {
        this.truncatedDesc = `${this.slickDesc.substring(0, 120)}...`;
        this.showBtnVerMais = true;
      } else {
        this.truncatedDesc = this.slickDesc;
        this.showBtnVerMais = false;
      }
    }
  }

  // Função para emitir o evento quando o botão for clicado
  onOpenSidebar(): void {
    this.openSidebar.emit();
  }
  // Referência para a div de classe `s-s-l-inlineDiv`
  @ViewChild('inlineDiv', { static: true }) inlineDiv!: ElementRef;
  @ViewChild('productSwiper', { static: false }) productSwiperRef?: SwiperComponent;

  // Controla a visibilidade das setas de navegação do carrossel de produtos:
  // o próprio Swiper (watchOverflow, ligado no template) sabe se os slides
  // cabem todos na área visível ou não — "lock"/"unlock" disparam quando esse
  // estado muda (inclusive em resize).
  isProductSwiperLocked = false;
  onProductSwiperLock(): void {
    this.isProductSwiperLocked = true;
    this.cdr.markForCheck();
  }
  onProductSwiperUnlock(): void {
    this.isProductSwiperLocked = false;
    this.cdr.markForCheck();
  }
  ngAfterViewInit(): void {
    if (!this.inlineDiv) {
      return;
    }
    if (this.videoUrls && this.videoUrls.length > 0) {
      // Observador para monitorar mudanças no tamanho da div
      this.resizeObserver = new ResizeObserver(() => {
        if (this.videoUrls && this.videoUrls.length > 0) {
          this.calculateLayout();
        }

      });
      this.resizeObserver.observe(this.inlineDiv.nativeElement);
    }

  }
  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

  }
  private calculateLayout(): void {
    if (!this.inlineDiv || !this.inlineDiv.nativeElement) {
      return;
    }
    if (this.videoUrls && this.videoUrls.length > 0) {
      let width = this.inlineDiv.nativeElement.offsetWidth;
      this.viewportService.setDivWidth(width); // Atualiza o Signal com a nova largura
      this.viewportService.setTemplateType(this.templateType); // Atualiza o Signal com a nova largura

      let numericAspectRatio: number;
      if (typeof this.aspectRatio === 'string') {
        try {
          numericAspectRatio = eval(this.aspectRatio); // Converte "540 / 540" para 1
        } catch (e) {
          console.error('Erro ao avaliar aspectRatio:', e);
          numericAspectRatio = 1; // Valor padrão caso haja erro
        }
      } else {
        numericAspectRatio = this.aspectRatio;
      }
      const maxHeight = 30 * 16;
      // Calcular a altura com base na largura e numericAspectRatio
      if (numericAspectRatio && numericAspectRatio > 0) {
        let height = width / numericAspectRatio; // Cálculo da altura
        if (height > maxHeight) {
          height = this.inlineDiv.nativeElement.offsetHeight;
        }

        this.viewportService.setDivHeight(height); // Atualiza altura no serviço
      }
    }
  }


  isPlaying: boolean = true; // Para gerenciar o estado de play/pause
  isMuted: boolean = true;   // Para gerenciar o estado de mute/unmute

  togglePlay(): void {
    if (this.videoPlayer) {
      const videoElement = this.videoPlayer.nativeElement;
      if (videoElement.paused) {
        videoElement.play();
        this.isPlaying = true;
      } else {
        videoElement.pause();
        this.isPlaying = false;
      }
    }
  }

  toggleMute(): void {
    this.isMuted = !this.isMuted;
    if (this.videoPlayer) {
      this.videoPlayer.nativeElement.muted = this.isMuted;
    }
  }
  get filteredProducts() {
    console.log('produto no inline')
    console.log(this.selectedVideoUrl?.products)
    return this.selectedVideoUrl?.products?.filter(p => p.show_item) || [];
  }
  @Input() arraySlicksFull: Item[] = [];
  @Input() totalAssets: number = 0;
  @Output() modalOpened = new EventEmitter<VideoItem>();
  openModal(video: VideoItem) {
    if (this.videoPlayer) {
      const videoElement = this.videoPlayer.nativeElement;
      if (!videoElement.paused) {
        videoElement.pause();
        this.isPlaying = false;
      }
    }

    this.modalOpened.emit(video);


    // novo 
    void this.videoModalService.open({
      video,
      slicks: this.arraySlicksFull,
      totalAssets: this.totalAssets,
      isAdmin: this.isAdmin,
      widgetId: this.widget_id,
      storeId: this.store_id,
      templateId: this.template_id,
      height: this.height,
      instanceId: this.instanceId
    });
    this.cdr.detectChanges();
  }
  cartCount: number = 0;
  addToCart(product: any, event: any) {

  }
  showCartSidebar: boolean = false;
  show: boolean = false;
  openCartSidebar() {
    this.showAllProductsSidebar2 = false;
    if (this.show) {
      this.sidebarCartService.openSidebar();
    } else {
      this.showCartSidebar = true;
    }
    this.shoppingCartService.loadCart();
  }
  hasDiscount(p: any): boolean {
    if (!p) return false;

    const price = Number(
      typeof p.price === 'string' ? p.price.replace(',', '.').trim() : p.price
    );
    const compare = Number(
      typeof p.compare_at_price === 'string'
        ? p.compare_at_price.replace(',', '.').trim()
        : p.compare_at_price
    );

    return !!compare && compare > price;
  }
}
